export enum AnimalDesires {
  Reproduce = "Looking for Mate",
  Food = "Looking for Food",
  Water = "Looking for Water",
}
